import { AfterViewInit, ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfirmDialogModel } from 'app/modules/common/components/confirmation-dialog/confirm-dialog-model';
import { ConfirmationDialogComponent } from 'app/modules/common/components/confirmation-dialog/confirmation-dialog.component';
import { SharedService } from 'app/modules/common/services/shared-service';
import { CompanyTreeNode } from 'app/modules/fuse/components/tree-view/entities/selected-company.model';
import { CompanyTreeViewService } from 'app/modules/fuse/components/tree-view/service/company-tree-view.service';
import { EmpresaService } from '../../../services/empresa.service';

@Component({
    selector: 'app-attached-companies',
    templateUrl: './attached-companies.component.html',
    styleUrls: ['./attached-companies.component.scss'],
    standalone: false
})
export class AttachedCompaniesComponent implements OnInit, AfterViewInit {
 
  private companyList: any[]
  private padreId: number
  private company = {
    PadreId: null,
    EmpresaId: null
  }
  public companyForm: UntypedFormGroup;

  public selectedEmpresaId : any;

  constructor(
    private _dialog: MatDialog,
    private _companyTreeService: CompanyTreeViewService,
    private _cdRef: ChangeDetectorRef,   
    private _empresaService: EmpresaService,
    private _sharedService: SharedService,
    public _formBuilder: UntypedFormBuilder,
    public _dialogRef: MatDialogRef<AttachedCompaniesComponent>, 

    @Inject(MAT_DIALOG_DATA) private dialogData: any,
    ) 
    {        
      this.companyList = dialogData.companyList
      this.padreId = dialogData.padreId
    }

  ngAfterViewInit(): void
  {
      const company = new CompanyTreeNode();   
      this._companyTreeService.setSelectedCompany(company);         
      this._cdRef.detectChanges();  
  }

  ngOnInit(): void
  {
  }

  public onCompanySelcted(node: any): void 
  {
    this.selectedEmpresaId = node.id; 
  }

  public addCompany(): void 
  {
    //company name selected by user        
    if (this.companyList.find(t => t['empresaId'] == this.selectedEmpresaId)) {
      //restrict adding the same company  
        this._sharedService.ShowSnackBar('La empresa ya está adjuntada');
    } else 
    {
      //sets the parentId and empresa Id
      this.company.PadreId = this.padreId 
      this.company.EmpresaId =  this.selectedEmpresaId

      this._empresaService.AddAdjuntos(this.company)
      .subscribe(res => {
        if (res.code === 0) {
          this._sharedService.ShowSnackBar('Guardado con éxito');
          this.cancel(true)
        } else {
          this._sharedService.ShowSnackBar('Error al crear');
          this.cancel(false)
        }
      }, err => {
        this._sharedService.ShowSnackBar('Se produjo un error');
        console.error(err);
      });
 
    }
  }

  cancel(submitSuccess: boolean) {
    this._dialogRef.close(submitSuccess == null ? false : submitSuccess);
  }
}
